/* eslint-disable no-useless-catch */
import {
  addSubcriptions,
  getBasket,
  getSubscriptions,
  getSubscriptionsWithoutSession
} from '@/api/simo';
import { getSessionStorage, setSessionStorage } from '@/utils/session';

export const fetchSimoSubscription = async (btl?: boolean) => {
  let result;
  const session = getSessionStorage('_session');
  try {
    if (!session) {
      result = await getSubscriptions(btl);
      setSessionStorage('_session', result._session);
    } else {
      result = await getSubscriptionsWithoutSession({ _session: session }, btl);
    }

    return { subscriptionsGlobal: result, loadingGlobal: false };
  } catch (error) {
    console.error(error);
    return { error: true, errorMessage: error };
  }
};

export const fetchBasket = async (session: string) => {
  try {
    const response = await getBasket({ _session: session });
    setSessionStorage('_session', response._session);
    return { responseCode: response.status, basket: response };
  } catch (error) {
    throw error;
  }
};

export const createBasket = async (productCode: string, session: string, noOfsubs: number) => {
  try {
    const response = await addSubcriptions({
      productCode,
      _session: session,
      numberSubscriptions: noOfsubs
    });
    setSessionStorage('_session', response._session);
    return { responseCode: '', basket: response };
  } catch (error) {
    throw error;
  }
};

export const fetchWithTimeout = async (resource: string, options: any) => {
  const { timeout = 8000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal
  });

  clearTimeout(id);
  return response;
};
